export default __webpack_public_path__ + "static/media/cepillateLosDientes.f8b17049.gif";